import { DestroyRef, Injectable } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { BehaviorSubject, map, skip, tap } from "rxjs";

import { environment } from "src/environments/environment";
import { DropdownOption } from "../shared/mine-dropdown/mine-dropdown.interface";
import { ContentPipe } from "../services/content/content.pipe";
import { LoggerService } from "../logger/logger.service";
import { TenantEnum } from "../core/models/tenant.enum";

@Injectable({
    providedIn: 'root'
})
export class TenantService {
    private readonly loggerName: string = 'TenantService';

    private tenantSubject = new BehaviorSubject<DropdownOption>(undefined);

    constructor(
        private logger: LoggerService,
        private destoryRef: DestroyRef,
        private contentPipe: ContentPipe,
    ) {
        this.initTenant();
    }

    private initTenant(): void {
        this.logger.debug(this.loggerName, `Initializing tenant service`);

		const currentUrl = window.location.href;
		const currentTenant = currentUrl.includes(environment.tenant.us) ? TenantEnum.US: TenantEnum.EU;

        this.setTenant(currentTenant);
        this.subscribeToTenantChanges();
    }

    private subscribeToTenantChanges(): void {
        this.tenantSubject.asObservable().pipe(
            skip(1),
            tap(value => this.logger.debug(this.loggerName, `Switching tenant to: ${value.id}`)),
			map(value => this.navigateToTenant(value.id as TenantEnum)),
			takeUntilDestroyed(this.destoryRef)
		).subscribe();
    }

    private navigateToTenant(tenant: TenantEnum): void {
        const newUrl = new URL(environment.tenant[TenantEnum[tenant]]);
        newUrl.pathname = window.location.pathname;
        newUrl.search = window.location.search;
        newUrl.hash = window.location.hash;
        window.location.href = newUrl.toString();
    }

    getTenant(): DropdownOption {
        return this.tenantSubject.getValue();
    }

    setTenant(tenant: TenantEnum): void {
        const value: string = this.tenantOptionValue(tenant);

        this.tenantSubject.next({
			id: tenant,
			value
		} as DropdownOption);
    }

    get tenantOptions(): DropdownOption[] {
        return Object.keys(TenantEnum).map(key => {
            const value: string = this.tenantOptionValue(TenantEnum[key]);

            return {
                id: key,
                value
            } as DropdownOption;
        });
    }

    private tenantOptionValue(tenant: TenantEnum): string {
        return this.contentPipe.transform(`common.${tenant}`);
    }
}